import { defaultData, devModeConfig } from "../../app/components/DevMode.helpers";
import * as immutable from 'object-path-immutable'
import { emptyArray, emptyFunction } from "../utils";
import { uuid } from "../../app/helpers/flows/HelperFunctions";
import { flattenTree } from "react-accessible-treeview";

const defaultState = {
  tabs: emptyArray,
  primitivas: emptyArray,
  operaciones: emptyArray,
  templates: emptyArray,
  selectedTab: -1,
  operationsEditor: {
    connectionTypes: [],
    nodeTypes: [],
  },
  navigator: {
    url: "",
  },
  explorer: {
    data: defaultData,
    treeData: flattenTree(defaultData),
    expandedIds: [],
    selectedId: null,
  }
}

const splitStringByFirstCapital = (string) => {
  // Encuentra todas las coincidencias de una letra mayúscula seguida de una minúscula o el final de la cadena
  const matches = string.match(/[A-Z][a-z]+|$[A-Z]+/g);
  
  // Retorna la primera palabra encontrada
  return matches ? matches[0] : null;
}

export const updateData = (data, folder, list, type) => {
  const idFolder = devModeConfig[type].idFolder;
  const result = searchElementData(data, idFolder);
  console.log("updateDate", {data, folder, list, type, result});

  const newData = list.sortBy(item => item.nombre).map(item => ({ 
      metadata: {
        type: type, 
        item: {...item, id: item.id.toString().startsWith("0-") ? 0 : item.id }, 
        subFolder: splitStringByFirstCapital(item.nombre),
        isNewFile: item.id.toString().startsWith("0-"),
      },
      name: item.nombre, 
      id: item._elementId
    }))
    .groupBy((item) => item.metadata.subFolder, (subFolder, items) => {

      return {
          name: subFolder,
          metadata: { type },
          id: `${folder}_${subFolder}`,
          isBranch: true,
          children: items
        };
    }).sort((a, b) => {
      if((a.isBranch && b.isBranch) || (!a.isBranch && !b.isBranch)){
        if (a.nombre < b.nombre) return -1;
        if (a.nombre > b.nombre) return 1;
        return 0;
      } else {
        if (a.isBranch) return -1;
        if (b.isBranch) return 1;
        return 0;
      }
    })

  return immutable.set(data, `${result.path}.children`, newData);
}

export const updateDataOpenFiles = (data, tabs) => { 
  const result = searchElementData(data, devModeConfig.ids.OPEN_TABS);
  if (!result) return data;
  const newData = {
    name: `${devModeConfig.captions.OPEN_TABS} (${tabs.length})`,
    children: tabs.sortBy(tab => tab.data.name).map(tab => ({...tab.data, id: `${tab.data.id}/open`}))
  }
  console.log("update data open files", {data, tabs, newData, result})
  return immutable.assign(data, result.path, newData);
}

export const addFileInFolder = (data, folderElement, file) => {
  const result = searchElementData(data, folderElement.id);
  return immutable.insert(data, `${result.path}.children`, file, 0);
}


export const searchElementData = (data, id) => {
  let result = [];
  searchElementData2(data, id, "", 0, result);
  return result.length === 0 ? null : result[0];
}

export const searchElementData2 = (data, id, path = "", level = 0, matches = [], foldersIds = []) => {
  if(data?.id === id){
    matches.push({data, path, level, foldersIds});
    return;
  }
  if(!data?.children) return ;
  data.children.forEach((item, index) => {
    if(matches.length > 0) return;
    searchElementData2(
      item, 
      id, 
      !!path ? path + ".children." + index : "children." + index, 
      level + 1, 
      matches,
      item.isBranch ? [...foldersIds, item.id] : foldersIds
    );
  }); 

}

export const setExpandedFolders = (ids, expanded, expandedIds) => {
  if(expanded){
    return ids.reduce((prevExpandedIds, currentId) => {
      const index = prevExpandedIds.findIndex(id => id === currentId);
      if(index === -1){
        return [...prevExpandedIds, currentId];
      }
      return prevExpandedIds;
    }, expandedIds)
  }else{
    return expandedIds.reduce((prevExpandedIds, currentId) => {
      if(ids.includes(currentId)){
        return prevExpandedIds;
      }
      return [...prevExpandedIds, currentId];
    }, [])
  }
}

export const deleteElement = (source, arrayPath, predicate = emptyFunction) => {
  const indexItem = immutable.get(source, arrayPath).findIndex(predicate);
  return immutable.del(source, `${arrayPath}.${indexItem}`);
}

export const newItem = {
  [devModeConfig.template.type]: (payload) => ({
    "descripcion": null,
    "fechaCreacion": new Date(),
    "fechaEliminacion": null,
    "fechaModificacion": new Date(),
    "id": 0,
    "idTemplateOriginal": null,
    "jsonMock": null,
    "nombre": payload.name,
    "template": "",
    "tipoTemplate": "",
    "titulo": payload.name
  }),
  [devModeConfig.operacion.type]: (payload) => ({
    "activa": 1,
    "descripcion": "",
    "fechaCreacion": new Date(),
    "fechaEliminacion": null,
    "fechaModificacion": new Date(),
    "guid": uuid(),
    "id": 0,
    "idProducto": null,
    "imagen": null,
    "nombre": payload.name,
    "orden": 0,
    "tipoOperacion": ""
  }),
  [devModeConfig.primitiva.type]: (payload) => ({
    "accionPrimitivaDO": "",
    "accionPrimitivaUNDO": null,
    "condicionRespuesta": null,
    "descripcion": "",
    "fechaCreacion": new Date(),
    "fechaEliminacion": null,
    "fechaModificacion": new Date(),
    "id": 0,
    "metodo": "",
    "nombre": payload.name,
    "reintentos": null,
    "templateBodyJson": "",
    "templateBodyJsonOutput": "",
    "tiempoEsperaMilisegundos": null,
    "tiempoEsperaReintentos": null,
    "titulo": payload.name,
    "url": ""
  })
}

export const prepareItem = (item, _type, _controllerName) => {
  return {...item, _elementId: `${item.id}-${_type}`, _controllerName, _type};
}

export const getSavedState = () => {
  return {
    ...defaultState,
    navigator: getSavedNavigatorState(),   
  }
}

export const getSavedNavigatorState = () => {
  const data = localStorage.getItem("dev-navigator");
  if(!!data){
    try{
      return JSON.parse(data);
    }catch(e){
      return defaultState.navigator;
    }
  }else{
    return defaultState.navigator;
  }
}